import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSetting, type SettingKey } from '../settings.api';

export interface SettingChange {
  key: SettingKey;
  value: unknown;
}

export interface UpdateSettingsInput {
  changes: SettingChange[];
  auditNote: string;
}

/** Writes every changed key sequentially (each write is its own audited PUT), then refetches. */
export function useUpdateSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ changes, auditNote }: UpdateSettingsInput) => {
      let latest;
      for (const change of changes) {
        latest = await updateSetting(change.key, change.value, auditNote);
      }
      return latest;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['admin', 'settings'] });
      // FR16 "direct doorwerken": the orderlijst's own settings read must reflect the change too.
      void queryClient.invalidateQueries({ queryKey: ['orders', 'settings'] });
    },
  });
}
